import React from 'react'
import { Button, Icon } from 'antd'
import './styles.scss'

export default ({file, on_download, on_expand_options, on_navigate }) => {
  const {basename, path, size, type} = file
  return (
    <a className='file-item columnWrap' onDoubleClick={()=> type === 'FS_FILE_TYPE_FILE' ? on_expand_options(file) : on_navigate(file)}>

      { type === 'FS_FILE_TYPE_FILE' ? <Icon type="file-text"/> : <Icon type="folder" />}

      <span>{basename}</span>
      {
        <div className={'expand'}>
          <Button ghost icon="download" size={'small'} onClick={()=>on_download(file)}/>
        </div>
      }

    </a>
  )
}
